<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../../configs/text';
import Heading from '../../General/Heading.vue';
import { useSessionStore } from '../../../stores';

const sessionStore = useSessionStore()

const { t } = useI18n()
</script>

<template>
    <div class="h-full w-full flex flex-col items-center justify-evenly overflow-auto">
        <Heading color="main" size="large" alignment="center" class="mt-auto">
            {{ t(TEXT.practice_completed) }}
        </Heading>
        <div class="flex items-center gap-2 border-2 border-orange-600 text-orange-600 rounded-lg p-5 mt-7 mb-auto">
            <span>{{ t(TEXT.correct_answer) }}</span>
            <span class="font-bold text-3xl">
                {{ sessionStore.currentPracticeResult?.quest_correct }}/{{
                    sessionStore.currentPracticeResult?.total_quest }}
            </span>
        </div>
    </div>
</template>